/* eslint-disable */

export default {
  init() {
	$(document).ready(function() {
		// JavaScript to be fired on all pages
		$(window).scroll(function() {
			var scroll = $(window).scrollTop();
			if (scroll >= 200) {
				$("header").addClass("position-fixed");
			} else {
				$("header").removeClass("position-fixed");
			}
		});

		let lastSrc = [];
		for(let i = 0; i < $('iframe').length; i++) {
			let times = [], playY = [];
			times[i] = 0;
			$($('.play-button')[i]).click(function(){
				lastSrc.push($($($('input.iframe')[i]).attr('value')).attr('src'));
				playY[i] = $($('iframe')[i]).attr('src', lastSrc + '&autoplay=1');
				times[i] = 1;
				$($('iframe')[i]).show();
				$($('.img-cover')[i]).hide();
				$($('.overlay-video')[i]).hide();
				$($('.play-button')[i]).hide();
			});
		}
		$('.form-textarea textarea').on('focusin', function(){
			$(this).parent().addClass('selected');
			$('.form-textarea p').addClass('selected');
			$(this).css('height', 'auto');
		});
		$('.form-textarea textarea').on('focusout', function(){
			if($(this).val() === '') {
				$(this).parent().removeClass('selected');
				$('.form-textarea p').removeClass('selected');
			}else {
				$(this).parent().addClass('selected');
				$('.form-textarea p').addClass('selected');
				$(this).css('height', 'auto');
			}
		});
		// $('.form-textarea textarea').attr('maxlength', '500');
		//Check if length is more than 500
		$('.form-textarea textarea').on('input paste',function(){
			if($(this).val().length > 500){
				$(this).val($(this).val().substr(0, 500));
				//check if there is already a warning
				if($('.form-textarea .wpcf7-not-valid-tip').length === 0) {
					$('.form-textarea .wpcf7-form-control-wrap').append('<span class="wpcf7-not-valid-tip">Vous avez atteint la limite de caractères</span>');
				}
			}else{
				$('.form-textarea .wpcf7-not-valid-tip').remove();
			}
		});

		//contact form
		$('.form-select select').on('focusin', function(){
			$(this).parent().addClass('selected');
			$('.form-select p').addClass('selected');
		});
		$('.form-select select').on('focusout', function(){
			if($(this).val() === '') {
				$(this).parent().removeClass('selected');
				$('.form-select p').removeClass('selected');
			}else {
				$(this).parent().addClass('selected');
				$('.form-select p').addClass('selected');
			}
		});
		$('.form-input input').on('focusin', function(){
			$(this).parent().addClass('selected');
		});
		$('.form-input input').on('focusout', function(){
			if($(this).val() === '') {
				$(this).parent().removeClass('selected');
			}else {
				$(this).parent().addClass('selected');
			}
		});
		$('#civility').change(function(){
			if($('#civility').val() !== '') {
				$(this).addClass('selected');
			} else {
				$(this).removeClass('selected');
			}

		});
		// $('.form-submit').click(function(){
		// 	console.log($('.checkboxes .wpcf7-form-control-wrap input.required')[0].checked);
		// 	if($('.checkboxes .wpcf7-form-control-wrap input.required')[0].checked !== true) {
		// 		$('.checkboxes .wpcf7-form-control-wrap .wpcf7-form-control:not(.optional)').append('<span class="wpcf7-not-valid-tip">Veuillez cocher cette case</span>');
		// 	}
		// });
	});

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js